import LocationPopup from './LocationPopup';

export default LocationPopup;
